import React from 'react';
import SchemaManager from '../../components/SchemaManager';

const AdminHiringAds = () => {
  return (
    <div className="container-fluid py-4">
      <div className="d-flex justify-content-between align-items-center mb-4">
        <h2>Vie administrative</h2>
        <small className="text-muted">
          Gérer les annonces de la vie administrative (offres d'emploi, avis, etc.)
        </small>
      </div>
      
      <SchemaManager
        schemaKey="hiring-ads"
        endpoint="/api/hiring-ads"
      />
    </div>
  );
};

export default AdminHiringAds;